/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    title: "Hoạt động phân phối, cung cấp hàng hóa",
    valueA: "",
  },
  {
    id: uuidV4(),
    title: "Hoạt động dịch vụ, xây dựng không bao thâu nguyên vật liệu",
    valueA: "",
  },
  {
    id: uuidV4(),
    title:
      "Hoạt động sản xuất, vận tải, dịch vụ có gắn với hàng hóa, xây dựng có bao thầu nguyên vật liệu",
    valueA: "",
  },
  {
    id: uuidV4(),
    title: "Hoạt động kinh doanh khác",
    valueA: "",
  },
];

export default function TaxPersonalTable02({ formData, setFieldValue, count }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (id === item.id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Typography variant="h5">B. CHI TIẾT DOANH THU TÍNH THUẾ THEO HÓA ĐƠN</Typography>
      <Typography variant="h5" mt={2}>
        I. KHAI THUẾ GTGT, TNCN
      </Typography>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td
                rowSpan={3}
                style={{ textAlign: "center", width: 10, background: "#d7d7d7", fontWeight: 800 }}
              >
                STT
              </Td>
              <Td
                rowSpan={3}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Nội dung
              </Td>
              <Td
                rowSpan={3}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Chi tiêu
              </Td>
              <Td
                rowSpan={2}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Doanh thu theo hóa đơn
              </Td>
              <Td
                rowSpan={1}
                colSpan={2}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Số thuế phải nộp
              </Td>
            </tr>
            <tr>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Thuế GTGT
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                Thuế TNCN
              </Td>
            </tr>
            <tr>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                (a)
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                (b)
              </Td>
              <Td
                rowSpan={1}
                style={{ textAlign: "center", background: "#d7d7d7", fontWeight: 800 }}
              >
                (c)
              </Td>
            </tr>

            {data.map((item, index) => (
              <tr key={item.id}>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  {index + 1}
                </Td>
                <Td rowSpan={1} style={{ textAlign: "left", maxWidth: 100, fontStyle: "italic" }}>
                  {item.title}
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                  [{index + 26}]
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    id={item.id}
                    name="valueA"
                    value={item.valueA}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                  0
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                  0
                </Td>
              </tr>
            ))}
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                5
              </Td>
              <Td
                rowSpan={1}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                Tổng cộng
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#ddeff3" }}>
                [30]
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
            </tr>
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, id, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ value: newValue !== "" ? +newValue : "", name, id });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
